import { Action, Selector, State, StateContext } from '@ngxs/store';
import { BrickDefinition } from '../../../../samwebDescription/samweb/brickDefinition';
import _ from 'lodash';
import { ImmutableContext } from '@ngxs-labs/immer-adapter';
import { PublishNewBrickDefinitions } from './brick-definition.actions';
import { Injectable } from '@angular/core';

export interface BrickDefinitionStateModel {
   definitions: BrickDefinition[];
}

@State<BrickDefinitionStateModel>({
   name: 'brickDefinition',
   defaults: {
      definitions: [],
   },
})
@Injectable()
export class BrickDefinitionState {
   @Selector([BrickDefinitionState])
   public static brickDefinitionsAsArray(state: BrickDefinitionStateModel): { [p: string]: BrickDefinition } {
      return _(state.definitions)
         .keyBy((x) => x.brickDefinitionId)
         .value();
   }

   @Selector([BrickDefinitionState])
   public static brickDefinitions(state: BrickDefinitionStateModel): BrickDefinition[] {
      return state.definitions;
   }

   @Selector([BrickDefinitionState.brickDefinitionsAsArray])
   public static brickDefinitionByIdFn(brickDefinitionsAsArray: { [p: string]: BrickDefinition }) {
      return (brickDefinitionId: string) => {
         return brickDefinitionsAsArray[brickDefinitionId];
      };
   }

   @Action(PublishNewBrickDefinitions)
   @ImmutableContext()
   public publishNewBrickDefinition(ctx: StateContext<BrickDefinitionStateModel>, action: PublishNewBrickDefinitions) {
      ctx.setState((x: BrickDefinitionStateModel) => {
         x.definitions = action.brickDefinitions;
         return x;
      });
   }
}
